import { memo } from "react"
import { Heading, HeadingProps } from "@chakra-ui/react"
import { HeadingSizeProps } from "./types"

const BeatHeading = (props: HeadingProps & HeadingSizeProps) => {
  const { color = "black", size, ...rest } = props

  return <Heading size={size} as={size} color={color} {...rest} />
}

export default memo(BeatHeading)
